module.exports = __webpack_public_path__ + "img/ask_ai_mobile.1cc01d67.png";